<div class="row" style="height: 25px; background:#114B43">

</div>
<div>
    <div class="container text-center mt-4 mb-2">
        <img src="./assets/images/logo-ust.svg" alt="logo" class="img-fluid" style="height: 120px;" />
    </div>
</div>
<div class="container aline-center">
    <div class="d-flex justify-content-center">
        <div class="d-flex flex-column">
            <div class="p-2">
                <h3>Estas saliedo fuera del sitio </h3>
            </div>
            <div class="p-2">
                <button  type="button" class="btn btn-primary btn-sm btn-block" (click)="volver()" style="background-color: #114B43!important; border-color:#114B43;">volver</button>
            </div>
        </div>
    </div>
</div>